import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './router'
import { applyTheme, getTheme } from './lib/theme'
import { startStaleBuildWatcher } from './lib/stale-build-watcher'
import './index.css'

// Apply persisted theme before first paint (avoid flash)
applyTheme(getTheme())

// Push-only service worker (no caching) — needed for PWA web-push notifications.
if ('serviceWorker' in navigator) {
  void navigator.serviceWorker.register('/sw.js')
}

// Primary stale-deploy path: detect the new build early and let the router turn the
// next navigation into a clean full page load (stale-build-watcher + router.tsx).
startStaleBuildWatcher()

// Last-resort stale-deploy recovery: a navigation that races the watcher (deployed
// seconds ago, no check ran yet) still 404s its lazy import. Vite fires
// vite:preloadError — reload once to fetch the fresh index.html (guard prevents a
// reload loop). This is the jarring path; the watcher above exists so users almost
// never hit it.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'chunk-reload-at'
  const last = Number(sessionStorage.getItem(KEY) ?? 0)
  if (Date.now() - last < 30_000) return // already reloaded recently — let the error surface
  sessionStorage.setItem(KEY, String(Date.now()))
  event.preventDefault()
  window.location.reload()
})

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found in DOM')

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
